export default __webpack_public_path__ + "25b7c0905ac46daca7711ae1da9ac875.jpeg";